import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';


class Log {
    getIssueTypes() {
        const endpoint = formatEndpoint(endpoints.log.getIssueTypes);
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    reportIssue(issueObj) {
        const endpoint = formatEndpoint(endpoints.log.reportIssue);
        return RestManagerWithoutBaseUrl.post(endpoint, issueObj);
    }
}

export default new Log();
